import api from './api';

const doctorService = {
  // Obtener todos los médicos
  getAllDoctors: async () => {
    const response = await api.get('/doctors');
    return response.data;
  },

  // Obtener médico por ID
  getDoctor: async (id) => {
    const response = await api.get(`/doctors/${id}`);
    return response.data;
  },

  // Crear perfil de médico
  createProfile: async (data) => {
    const response = await api.post('/doctors', data);
    return response.data;
  },

  // Actualizar perfil
  updateProfile: async (id, data) => {
    const response = await api.put(`/doctors/${id}`, data);
    return response.data;
  },

  // Obtener mi perfil
  getMyProfile: async () => {
    const response = await api.get('/doctors/me/profile');
    return response.data;
  },

  // Obtener mi balance (pagos netos por consultas completadas)
  getMyBalance: async () => {
    const response = await api.get('/doctors/me/balance');
    return response.data;
  },

  // Obtener slots disponibles (30 min, hora de Bogotá GMT-5) para una fecha
  // dada (YYYY-MM-DD). Usado por el paciente al agendar cita.
  getAvailableSlots: async (doctorId, date) => {
    const response = await api.get(`/doctors/${doctorId}/slots`, { params: { date } });
    return response.data;
  },

  // Slots libres de todos los médicos durante 7 días desde `start` (YYYY-MM-DD,
  // hora de Bogotá): { dates, availability: { [doctorId]: { [fecha]: ['HH:MM'] } } }
  getWeeklySlots: async (start) => {
    const response = await api.get('/doctors/slots/week', { params: { start } });
    return response.data;
  }
};

export default doctorService;
